import React, { useEffect, useState } from "react";
import { useIncomingInvoice } from "../../DataStore/IncomingInvoiceContext";
import ActivityLoader from "../Common/ActivityLoader";
import Notification from "../Common/Notification";
import functions from "../../util/functions";
import { Link } from "react-router-dom";

const InvoiceReminder = () => {
  const [tooltip, setTooltip] = useState({
    visible: false,
    content: "",
    position: { x: 100, y: 0 },
  });

  const {recentOutstandingListing, getOutstandingInvoices, unpaidInvoiceCount, getUnpaidInvoiceCount} = useIncomingInvoice();

  useEffect(()=>{
    getOutstandingInvoices();
    getUnpaidInvoiceCount();
  }, []);


  const handleMouseEnter = (event, content) => {
    const rect = event.target.getBoundingClientRect(); // Get list item position
    setTooltip({
      visible: true,
      content,
      position: { x: rect.left - 270, y: rect.top + rect.height / 2 }, // Adjusted for tooltip alignment
    });
  };

  const handleMouseLeave = () => {
    setTooltip({ visible: false, content: "", position: { x: 0, y: 0 } });
  };


  return (
    <div className="card shadow-sm mb-4">
      <div className="card-body text-center">
        <h6 className="card-title text-danger">
          <i className="fa fa-bell text-danger mr-2"></i> Invoice Reminders
        </h6>
        {unpaidInvoiceCount*1 > 0 && <p className="text-dark small mb-3">
          You have <strong> {unpaidInvoiceCount} outstanding invoice{unpaidInvoiceCount*1 > 1 ? 's' : ''}</strong>! Clear {unpaidInvoiceCount*1 > 1 ? 'them' : 'it'} to avoid penalties.
        </p>}

        {/* List of Invoices */}
        <div className="overflow-auto mb-3" style={{ maxHeight: "230px" }}>
          <ul className="list-group list-group-flush text-left mb-3">
            {Array.isArray(recentOutstandingListing) && recentOutstandingListing.map((invoice, index) => (
              <li
                key={index}
                className="list-group-item d-flex justify-content-between align-items-center link"
                onMouseEnter={(e) => handleMouseEnter(e, invoice.tip)}
                onMouseLeave={handleMouseLeave}
              >
                <span className="text-truncate" style={{maxWidth: '100px'}}>
                 {invoice.vendor.title}
                </span>
                <span className="badge badge-warning text-truncate">{ functions.numberFormat(invoice.invoice_balance)}</span>
              </li>
            ))}
          </ul>
          {!recentOutstandingListing && <ActivityLoader />}
          {recentOutstandingListing === "404" && <Notification message={"No outstanding invoices found"} closable = {false}/>}
        </div>

        {/* Tooltip */}
        {tooltip.visible && (
          <div
            className="custom-tooltip"
            style={{
              top: `${tooltip.position.y}px`,
              left: `${tooltip.position.x - 60}px`,
            }}
          >
            {tooltip.content}
          </div>
        )}

        {/* Action Button */}
        <Link to="/expenses-invoicing" className="btn-pill btn btn-outline-primary btn-sm">
          <i className="fa fa-eye mr-1"></i> View All
        </Link>
      </div>
    </div>
  );
};

export default InvoiceReminder;
